"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const storm_ui_1 = require("@amzn/storm-ui");
const react_1 = __importDefault(require("react"));
const storm_ui_icons_1 = require("@amzn/storm-ui-icons");
const regionUtils_1 = require("../../../utils/regionUtils");
const TranslationProvider_1 = require("../TranslationProvider/TranslationProvider");
const RegionSwitcherSelectorTrigger = react_1.default.forwardRef(({ onClick, currentRegionId }, ref) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const regionLabel = translate('region');
    const region = translate((0, regionUtils_1.getRegionLabel)(currentRegionId));
    const buttonLabel = regionLabel + ': ' + region;
    return ((0, jsx_runtime_1.jsxs)(storm_ui_1.Button, { onClick: onClick, buttonRef: ref, role: 'button', variant: 'default', children: [buttonLabel, (0, jsx_runtime_1.jsx)(storm_ui_1.Icon, { type: storm_ui_icons_1.angleDown })] }));
});
exports.default = RegionSwitcherSelectorTrigger;
//# sourceMappingURL=RegionSwitcherSelectorTrigger.js.map